<template>
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative z-50" @close="close">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
                <div class="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
                            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div class="sm:flex sm:items-start w-full">
                                    <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                                        <DialogTitle as="h3" class="text-base font-semibold text-gray-900">{{ $t('profile.portfolio_group_edit_modal.title') }}</DialogTitle>
                                        <div class="mt-2">
                                            <p class="text-sm text-gray-500">{{ $t('profile.portfolio_group_edit_modal.description') }}</p>
                                        </div>
                                        <div class="mt-4">
                                            <input type="text" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6" v-model="title" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button type="button" class="mb-3 inline-flex w-full justify-center rounded-md bg-royal-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-600 sm:mb-0 sm:ml-3 sm:w-auto cursor-pointer" @click="confirmAction">{{ $t('profile.portfolio_group_edit_modal.save_button') }}</button>
                                <button type="button" class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:w-auto cursor-pointer" @click="close" ref="cancelButtonRef">{{ $t('profile.portfolio_group_edit_modal.cancel_button') }}</button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';

export default defineComponent({
    name: "EditGroupInPortfolio",

    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
    },

    props: {
        open: {
            type: Boolean,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            title: null as string | null,
        };
    },

    watch: {
        value(newValue) {
            this.title = newValue;
        },
    },

    mounted() {
        this.title = this.value;
    },

    methods: {
        close() {
            this.$emit('close');
        },
        confirmAction() {
            this.$emit('confirm-action', this.title);
        },
    },
});
</script>